import { render, staticRenderFns } from "./consultaFE.vue?vue&type=template&id=d0f006f8&"
import script from "./consultaFE.vue?vue&type=script&lang=js&"
export * from "./consultaFE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports